import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    id: null,
    token: null,
    email: null,
    role: null,
    /** Identity from login; never overwritten by "view as" role switching */
    trueRole: null,
    permissions: [],
    verificationType: null,
    resetToken: null,
  },
  reducers: {
    userLogin: (state, action) => {
      state.id = action?.payload?.id;
      state.token = action?.payload?.token;
      state.role = action?.payload?.role;
      state.trueRole = action?.payload?.role;
      state.email = action?.payload?.email;
      state.permissions = action?.payload?.permissions || [];
    },
    setVerificationType: (state, action) => {
      state.verificationType = action?.payload;
    },
    setEmail: (state, action) => {
      state.email = action?.payload;
    },
    setResetToken: (state, action) => {
      state.resetToken = action?.payload;
    },
    clearResetToken: (state) => {
      state.resetToken = null;
    },
    /** Updates effective (UI) role only; does not change trueRole */
    setRole: (state, action) => {
      state.role = action?.payload;
    },
    restoreTrueRole: (state) => {
      if (state.trueRole != null) {
        state.role = state.trueRole;
      }
    },
    /** One-time migration for persisted sessions saved before trueRole existed */
    syncTrueRoleFromRole: (state) => {
      if (state.trueRole == null && state.role != null) {
        state.trueRole = state.role;
      }
    },
    logOut: (state) => {
      state.id = null;
      state.token = null;
      state.email = null;
      state.role = null;
      state.trueRole = null;
      state.permissions = [];
      state.verificationType = null;
      state.resetToken = null;
    },
  },
});

export const {
  userLogin,
  setVerificationType,
  setEmail,
  setResetToken,
  clearResetToken,
  setRole,
  restoreTrueRole,
  syncTrueRoleFromRole,
  logOut,
} = userSlice.actions;

export default userSlice.reducer;
